import config from '../config/config';

const uploadFile = async (s3Key, file) => {
  const uploadURL = config.apiURL + `/s3/stream_upload?key=${s3Key}`;
  const resp = await fetch(uploadURL, {
    method: 'POST',
    headers: { token: config.getToken() },
    body: file
  })
    .then((response) => response.json())
    .then(function (response) {
      let r = { response: response };
      return r;
    })
    .catch((error) => {
      console.error(error);
    });
  return resp;
};

export default uploadFile;
